import React from "react";

export default function TripIcon({ color = "#14B8A6" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_107_1233)">
        <path
          d="M13.3333 3.3335L11.3333 1.3335L9.33325 3.3335M11.3333 1.3335V9.3335M9.33325 6.66683L11.3333 4.66683L13.3333 6.66683M11.3333 9.3335H4.66659L1.33325 14.6668H14.6666L11.3333 9.3335ZM5.33325 9.3335V14.6668M5.99992 9.3335L9.33325 14.6668M3.99992 2.66683C3.99992 3.40321 3.40297 4.00016 2.66659 4.00016C1.93021 4.00016 1.33325 3.40321 1.33325 2.66683C1.33325 1.93045 1.93021 1.3335 2.66659 1.3335C3.40297 1.3335 3.99992 1.93045 3.99992 2.66683Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_1233">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
